function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import TextBox from './TextBox';
import '../assets/inputFields.css';
const NumberBox = props => /*#__PURE__*/React.createElement(TextBox, _extends({
  type: "number"
}, props, {
  key: props.name || +new Date()
}));
NumberBox.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  email: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number
};
export default NumberBox;